var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toolBar" }, [
    _c("div", { staticClass: "side1" }, [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              return _vm.concatUs()
            }
          }
        },
        [_c("span", [_vm._v("联系我们")])]
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "side2 side" }, [
      _c("a", { attrs: { href: "tel:400-1331-551" } }, [
        _c("i", [
          _c("img", {
            staticClass: "left_img",
            attrs: {
              src: "/static/image/icon_phone_cehua@2x.png",
              alt: "",
              title: "",
              la: "la"
            }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("400-1331-551")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "side3 side" }, [
      _c("a", { attrs: { href: "mailto:business@cnewmedical.com" } }, [
        _c("i", [
          _c("img", {
            staticClass: "left_img",
            attrs: {
              src: "/static/image/icon_email_cehua@2x.png",
              alt: "",
              title: "",
              la: "la"
            }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("business@cnewmedical.com")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "side5 side" }, [
      _c("a", [
        _c("i", [
          _c("img", {
            staticClass: "left_img",
            attrs: {
              src: "/static/image/icon_wechat_cehua@2x.png",
              alt: "",
              title: "",
              la: "la"
            }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("关注我们")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qcodePic animated fadeInUp" }, [
        _c("img", {
          staticClass: "gongzhonghao_img",
          attrs: {
            src: "/static/image/img_gongzhonghao_cehua@2x.png",
            alt: "",
            title: "",
            la: "la"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50871fd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50871fd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightTool.vue
// module id = null
// module chunks = 